import { CellContext } from "@tanstack/react-table";
import { pluralizeWithCount } from "@common/helpers/string";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { CountButtonCell } from "@components/items/Cells/CountButtonCell";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { ReportTemplateCallbacks } from "../ReportTemplatesList";
import { ReportTemplateRow } from "../reportTemplatesViewConfig";

export const ReportTemplateEntitiesCell = memo(
    ({
        row,
        table,
    }: CellContext<
        ViewTableFeatures,
        ReportTemplateRow,
        ReportTemplateRow["entities"]
    >) => {
        const { entities } = row.original;
        const { callbacks } = useViewTableMeta<ReportTemplateCallbacks, never>(
            table,
        );

        return (
            <CountButtonCell
                count={entities.length}
                ariaLabel={`View ${pluralizeWithCount("entity", entities.length)} using ${row.original.name}`}
                onClick={() => callbacks?.onViewApplied(row.original)}
            />
        );
    },
);
